import { render, staticRenderFns } from "./apiAuthorization2.vue?vue&type=template&id=399f8a94&scoped=true&"
import script from "./apiAuthorization2.vue?vue&type=script&lang=js&"
export * from "./apiAuthorization2.vue?vue&type=script&lang=js&"
import style0 from "./apiAuthorization2.vue?vue&type=style&index=0&id=399f8a94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f8a94",
  null
  
)

export default component.exports